import { Statistics } from '@models';

export interface ProjectStatisticsResult {
  projectStatistics: Statistics;
}
